export default function Detailedpartnersdisplay() {
  const partners = [{
    logo: "https://nucectd.com/wp-content/uploads/2026/06/NUCEWALL.jpg?v=sgh6pbxt4bc",
    srcset: "https://nucectd.com/wp-content/uploads/2026/06/NUCEWALL.jpg?v=ioogepc3pk-wvc-srcset",
    sizes: "https://nucectd.com/wp-content/uploads/2026/06/NUCEWALL.jpg?v=p0k6u9keu8p-wvc-sizes",
    alt: "Đại học Xây dựng Hà Nội (NUCEWALL)"
  }, {
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo1.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo1.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo1.png",
    alt: "FRP Việt Nam"
  }, {
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo-Delta.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo-Delta.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo-Delta.png",
    alt: "Công Ty TNHH Tập Đoàn Xây Dựng DELTA"
  }, {
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/images.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/images.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/images.png",
    alt: "CCU"
  }, {
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/Xay-dung-so.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/Xay-dung-so.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/Xay-dung-so.png",
    alt: "Công ty Cổ phần Truyền thông Xây Dựng Số"
  }, {
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/VITEC-CTCP-Giai-phap-Cong-nghe-Xay-dung-Quoc-te-Viet-Nam.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/VITEC-CTCP-Giai-phap-Cong-nghe-Xay-dung-Quoc-te-Viet-Nam.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/VITEC-CTCP-Giai-phap-Cong-nghe-Xay-dung-Quoc-te-Viet-Nam.png",
    alt: "VITEC"
  }];
  const marqueeItems = [...partners];
  return <section data-section-id="2072" id="detailedpartnersdisplay" className="bg-background text-foreground py-14 md:py-16 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          {}
          <div className="lg:col-span-3">
            <div className="font-default text-xs md:text-[13px] font-medium uppercase tracking-[0.18em] text-foreground">
              <span className="text-primary mr-1.5">§</span>
              02 / Đối tác chiến lược
            </div>
            <p className="mt-3 font-default text-xs md:text-sm tracking-[0.04em] uppercase text-muted-foreground">
              Nghiên cứu · Chuyển giao · Công nghệ
            </p>
          </div>

          {}
          <div className="lg:col-span-9 relative">
            <div className="group relative overflow-hidden" style={{
            maskImage: "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
            WebkitMaskImage: "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)"
          }}>
              <div className="flex items-center gap-12 md:gap-20 whitespace-nowrap animate-[grain-marquee_20s_linear_infinite] group-hover:[animation-play-state:paused] [animation-play-state:running] transition-[animation-play-state] duration-300" style={{
              width: "max-content"
            }}>
                {marqueeItems.map((partner, i) => <div data-index={i} key={i} className="flex items-center justify-center transition-all duration-[240ms] ease-out cursor-default select-none">
                    <img src={partner.logo} data-wvc-srcset={partner.srcset} data-wvc-sizes={partner.sizes} alt={partner.alt} loading="lazy" className="h-14 md:h-20 w-auto object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300" />
                  </div>)}
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="mt-12 md:mt-14 flex items-center">
          <div className="h-px flex-1 bg-border" />
          <div className="size-1.5 bg-primary ml-0" />
        </div>
      </div>

      <style>{`
        @keyframes grain-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}